import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/react-hooks';

import useDormifyGateway from './hooks/useDormifyGateway';
import VisualizerPage from './templates/VisualizerPage';
import { getSlugFromPathName } from './Utils/VisualizerUtils';

import DySlider from './components/DySlider/DySlider';

var VisualizerClient = function VisualizerClient(props) {
  var client = useDormifyGateway();
  return ReactDOM.createPortal(React.createElement(
    ApolloProvider,
    { client: client },
    React.createElement(VisualizerPage, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      queryParams: props.location.search,
      slug: getSlugFromPathName(props.location.pathname),
      toggleAccountModal: props.toggleAccountModal
    }),
    props.location.pathname.includes('wall-visualizer') ? React.createElement(DySlider, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      dySlug: 'wall-viz-slider'
    }) : React.createElement(DySlider, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      dySlug: 'viz-slider'
    })
  ), document.getElementById('react-visualizer'));
};

VisualizerClient.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  location: PropTypes.object,
  toggleAccountModal: PropTypes.func.isRequired
};

export default VisualizerClient;